b247.article = function() {

  var article = $('[data-article]');

  if (article.length) {

    // comments

    var comments = article.find('[data-article-comments]');

	if(comments.find('#comments-block').length>0) {
		comments.prepend('<a href="#" class="button button--full js-article-view-comments button--arrow"><span class="button__inner">View comments</span></a>');

	    $('.js-article-view-comments').click(function() {

	      comments.addClass('article__comments--show');
	      $(this).remove();
	      return false;

	    });
	
	}

    

    // adverts

    // var advert_interval = setInterval(function() {
    //
    //   if (ok_to_clone_article_advert) {
    //
    //     clearInterval(advert_interval);
    //
    //     setTimeout(function() {
    //
    //       var advert_one_clone = article.find('[data-article-adverts-advert="1"]').clone().attr('class', 'cms__advert cms__advert--article');
    //       $('[data-article-cms] > *:nth-child(2)').after(advert_one_clone);
    //
    //     }, 1000);
    //
    //   }
    //
    // }, 100);

  }

};
